/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useState } from 'react';
import { Badge, Button, DrawerBody, DrawerFooter, FormController, Link, Radio, RadioGroup, Typography, PaginationCompact, PaginationDisplayedItemCount, } from '@one-thd/sui-atomic-components';
import DrawerHeader from '../drawer/drawer-header';
import { useAddresses } from '../../../hooks/use-addresses';
import { ADDRESSES_PAGE_SIZE, PAGINATION_JUMP_CONTROLS_THRESHOLD, PAGINATION_THRESHOLD, } from '../../../constants/general';
export const SelectBillingAddress = ({ hideDrawer, onSave, getValues, onAddBilling, }) => {
    const { addresses } = useAddresses();
    const [page, setPage] = useState(1);
    const selectedBillingAddressID = getValues('billingAddressID');
    const [newlySelectedBillingAddressID, setNewlySelectedBillingAddressID] = useState(selectedBillingAddressID);
    const totalAddressesCount = Number(addresses === null || addresses === void 0 ? void 0 : addresses.addresses.length);
    const totalPageCount = Math.ceil(totalAddressesCount / ADDRESSES_PAGE_SIZE);
    const isPaginationVisible = totalAddressesCount > PAGINATION_THRESHOLD;
    const addressesPerPage = useMemo(() => {
        const list = (addresses === null || addresses === void 0 ? void 0 : addresses.addresses.slice(ADDRESSES_PAGE_SIZE * (page - 1), ADDRESSES_PAGE_SIZE * page)) || [];
        return list;
    }, [addresses, page]);
    const handleChangePage = (event, value) => {
        setPage(value);
    };
    const handleOnChange = (address) => {
        setNewlySelectedBillingAddressID(address.addrIdentifier);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerHeader, { showBackButton: true, title: "Select Billing Address", onClose: () => {
                hideDrawer();
            }, onBack: hideDrawer }),
        React.createElement(DrawerBody, null,
            React.createElement("div", { className: "sui-mb-6" },
                React.createElement(Link, { component: "button", onClick: onAddBilling }, "Add New Address")),
            React.createElement(FormController, null,
                React.createElement(RadioGroup, { "aria-labelledby": "address-radio-buttons-group-label", name: "address-select-group" }, addressesPerPage.map((address) => {
                    const { addrIdentifier, firstName, lastName, addressLine1, addressLine2, zipCode, city, state: addressState, isDefault, } = address;
                    return (React.createElement("label", { key: addrIdentifier, htmlFor: `${addrIdentifier}`, className: "sui-flex sui-items-start sui-mb-6" },
                        React.createElement(Radio, { checked: newlySelectedBillingAddressID === addrIdentifier, onChange: () => handleOnChange(address), id: `${addrIdentifier}` }),
                        React.createElement("div", null,
                            React.createElement(Typography, { "data-qm-mask": "" },
                                firstName,
                                " ",
                                lastName),
                            React.createElement(Typography, { "data-qm-mask": "" },
                                addressLine1,
                                ", ",
                                addressLine2 && `${addressLine2},`,
                                ' ',
                                city,
                                ", ",
                                addressState,
                                ", ",
                                zipCode),
                            isDefault && (React.createElement(Badge, { variant: "strong", color: "medium" }, "Default")))));
                }))),
            isPaginationVisible && (React.createElement("div", { className: "sui-flex sui-flex-col sui-items-center sui-gap-y-2", "data-testid": "PaginationWrap" },
                React.createElement(PaginationCompact, { count: totalPageCount, page: page, onChange: handleChangePage, showFirstButton: totalPageCount > PAGINATION_JUMP_CONTROLS_THRESHOLD, showLastButton: totalPageCount > PAGINATION_JUMP_CONTROLS_THRESHOLD }),
                React.createElement(PaginationDisplayedItemCount, { page: page, itemsPerPage: ADDRESSES_PAGE_SIZE, items: totalAddressesCount })))),
        React.createElement(DrawerFooter, null,
            React.createElement("div", { className: "sui-flex sui-gap-2" },
                React.createElement(Button, { fullWidth: true, variant: "secondary", onClick: () => {
                        hideDrawer();
                    } }, "Cancel"),
                React.createElement(Button, { fullWidth: true, variant: "primary", onClick: () => {
                        if (newlySelectedBillingAddressID !== null) {
                            onSave(newlySelectedBillingAddressID);
                        }
                        hideDrawer();
                    } }, "Save and Continue")))));
};
